// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"9e7cd1ea","769":"bd3c11c9"}[chunkId] + ".chunk.js";
};